/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamSteamAuthData interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamSteamAuthData(value) {
    if (!('SteamUserId' in value) || value['SteamUserId'] === undefined)
        return false;
    if (!('SteamSessionTicket' in value) || value['SteamSessionTicket'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamSteamAuthDataFromJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamSteamAuthDataFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamSteamAuthDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'SteamUserId': json['SteamUserId'],
        'SteamSessionTicket': json['SteamSessionTicket'],
    };
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamSteamAuthDataToJSON(json) {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamSteamAuthDataToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamSteamAuthDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'SteamUserId': value['SteamUserId'],
        'SteamSessionTicket': value['SteamSessionTicket'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersSteamSteamAuthData.js.map